export const selectSelectedClient = ({ auth }) => auth.selectedClient;
export const selectCurrentUser = ({ auth }) => auth.currentUser;
export const selectCurrentToken = ({ auth }) => auth.currentUser.token;
